import { Tooltip, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/material";
import CustomDatePicker from "../components/date-picker/DatePicker";
import { AvailableDate } from "../types";
import { useMemo } from "react";
import { Colors } from "../Colors";
import { countAvailableDays } from "../utils/availableDates";
import { generateAvailableDates } from "../services/webptPatientService";

const DatePickerField = ({
  dates,
  onDatesChange,
  placeholder = "Select dates",
  required = false,
}: {
  dates: AvailableDate[];
  onDatesChange: (dates: AvailableDate[]) => void;
  placeholder?: string;
  required?: boolean;
}) => {
  const handleAlwaysAvailableClick = () => {
    onDatesChange(generateAvailableDates(90));
  };

  const daysSelected = useMemo(() => countAvailableDays(dates), [dates]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={1}>
        <Tooltip title={required ? "This field is required" : ""}>
          <Typography variant="body1">
            Available Days ({daysSelected} selected){" "}
            {required && (
              <span style={{ color: Colors.error }}>
                *
              </span>
            )}
          </Typography>
        </Tooltip>
        <Button sx={{ textTransform: "none" }} onClick={handleAlwaysAvailableClick}>
          Patient is always available
        </Button>
      </Box>
      <CustomDatePicker dates={dates} onDatesChange={onDatesChange} placeholder={placeholder} inline />
    </>
  );
};

export default DatePickerField;
